import React from 'react';

export default function IconVN() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 22">
            <path
                fill="#FF4B55"
                d="M31.449 21.483H.552A.552.552 0 0 1 0 20.93V1.069C0 .764.247.517.552.517H31.45c.304 0 .551.247.551.552v19.862a.552.552 0 0 1-.551.552Z"
            />
            <path
                fill="#FFE15A"
                d="m16.258 4.748 1.475 4.425 4.664.036c.26.002.369.334.16.49l-3.753 2.77 1.407 4.447a.271.271 0 0 1-.416.302L16 14.506l-3.794 2.712a.271.271 0 0 1-.417-.302l1.407-4.447-3.752-2.77a.271.271 0 0 1 .16-.49l4.663-.036 1.476-4.425a.271.271 0 0 1 .515 0Z"
            />
        </svg>
    );
}
